import type { Topic } from '@/models/topic';

import { normalizeText } from './text';

export function buildCandidateProposalPath(slug: string): string {
  return `/proposta-candidato/${encodeURIComponent(slug)}`;
}

export function buildTopicSlug(value: string): string {
  return normalizeText(value).replace(/\s+/g, '-');
}

export function buildCandidateProposalTopicPath(slug: string, topicValue: string): string {
  return `${buildCandidateProposalPath(slug)}/${encodeURIComponent(buildTopicSlug(topicValue))}`;
}

export function buildCandidateProposalTopicPagePath(slug: string, topicValue: string, page?: number): string {
  const path = buildCandidateProposalTopicPath(slug, topicValue);

  if (typeof page !== 'number' || !Number.isFinite(page) || page <= 0) {
    return path;
  }

  return `${path}?page=${Math.trunc(page)}`;
}

export function findTopicBySlug(topics: Topic[], topicSlug: string): Topic | null {
  const normalizedTopicSlug = buildTopicSlug(topicSlug);

  return topics.find((topic) => buildTopicSlug(topic.label) === normalizedTopicSlug || buildTopicSlug(topic.id) === normalizedTopicSlug) ?? null;
}

export function buildCandidateProposalPagePath(slug: string, page?: number): string {
  const path = buildCandidateProposalPath(slug);

  if (typeof page !== 'number' || !Number.isFinite(page) || page <= 0) {
    return path;
  }

  return `${path}?page=${Math.trunc(page)}`;
}
